export default __webpack_public_path__ + "static/media/draft1.6c88d149.png";